<mat-form-field appearance="outline" fxFlex>
  <mat-label>{{ settings.nazev }}</mat-label>
  <input
    matInput
    [value]="dateValue"
    [matDatepicker]="picker"
    placeholder="{{ settings.nazev }}"
    [required]="settings.povinnost"
    (click)="picker.open()"
    (dateInput)="addEvent('input',$event)"
  />
  <mat-hint *ngIf="settings.napoveda && !settings.napoveda.isIcon">{{settings.napoveda.text}}</mat-hint>
  <mat-icon *ngIf="settings.napoveda && settings.napoveda.isIcon" matSuffix [matTooltip]="settings.napoveda.text">info</mat-icon>

  <mat-datepicker #picker></mat-datepicker>
  <mat-error *ngIf="firstError">
    {{firstError}}
  </mat-error>

</mat-form-field>
